import { useAsyncOperation } from "@core/hooks/use-async-operation";
import { healthcareTeamManager } from "@core/service-container";
import { HealthcareTeam } from "@domain/healthcare-team/healthcare-team";
import { useObservable } from "micro-observables";
import { useCallback, useEffect } from "react";

interface UseHealthcareTeamHook {
	loading: boolean;
	error: boolean;
	healthcareTeam: HealthcareTeam | null;
	refreshHealthcareTeam: () => Promise<void | undefined>;
}

export function useHealthcareTeam(patientId: string): UseHealthcareTeamHook {
	const healthcareTeam = useObservable(healthcareTeamManager.healthcareTeam);
	const fetchHealthcareTeam = useCallback(
		async () => await healthcareTeamManager.fetchHealthcareTeam(patientId),
		[patientId],
	);
	const [fetchHealthcareTeamData, loading, error] = useAsyncOperation(fetchHealthcareTeam, {});

	useEffect(() => {
		fetchHealthcareTeamData();
	}, [fetchHealthcareTeamData]);

	return { loading, error, healthcareTeam, refreshHealthcareTeam: fetchHealthcareTeamData };
}
